import type { DayLabel } from "@bundle/core";
import { Divider, Stack, Text } from "../primitives/index.ts";
import { useFormat, useT } from "../i18n/I18nProvider.tsx";

/** Centered day pill between two hairlines ("Today", "Monday, October 20"). */
export function DayDivider({ label }: { label: DayLabel }) {
  const fmt = useFormat();
  return (
    <Stack direction="horizontal" align="center" gap="2" paddingX="5" paddingY="2" testID="day-divider">
      <Stack grow>
        <Divider />
      </Stack>
      <Stack paddingX="2.5" paddingY="0.5" radius="full" border="border.subtle" background="bg.canvas">
        <Text variant="caption" weight="semibold" color="text.secondary">
          {fmt.day(label)}
        </Text>
      </Stack>
      <Stack grow>
        <Divider />
      </Stack>
    </Stack>
  );
}

/** Centered "NEW" marker before the first unread message. */
export function NewDivider() {
  const t = useT();
  return (
    <Stack direction="horizontal" align="center" gap="2" paddingX="5" paddingY="1" testID="new-divider">
      <Stack grow>
        <Divider color="badge.bg" />
      </Stack>
      <Stack paddingX="2" radius="full" background="badge.bg">
        <Text variant="caption" weight="bold" color="badge.fg">
          {t("channel.newDivider").toUpperCase()}
        </Text>
      </Stack>
      <Stack grow>
        <Divider color="badge.bg" />
      </Stack>
    </Stack>
  );
}
